import { useEffect, useState } from "react";
import { Icons } from "../../constants/icon-library";
import { formatDate } from "./Meetings.utils";

const MeetingHeader = ({
  user,
  meeting,
  onShowParticipants,
  onShowSummary,
  onShowTranscript,
  onDelete,
  onRename,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedName, setEditedName] = useState(meeting?.title || "");

  const handleSave = () => {
    if (editedName.trim() && editedName !== meeting?.title) {
      onRename?.(editedName);
    }
    setIsEditing(false);
  };

  useEffect(() => {
    setEditedName(meeting?.title || "");
  }, [meeting?.title]);

  const displayTimezone = meeting?.timezone || user?.timezone || "";

  return (
    <div className="d-flex align-items-start justify-content-between gap-3 mb-4 mt-3">
      <div className="flex-grow-1">
        {!isEditing ? (
          <>
            {" "}
            <div className="d-flex align-items-center gap-2">
              <h2 className="text-body-emphasis mb-1">
                {meeting?.title || "Untitled Meeting"}
              </h2>
              <button
                className="btn btn-sm text-muted"
                onClick={() => setIsEditing(true)}
              >
                <i className={`wb ${Icons("edit")} fs-8`} />
              </button>
            </div>
            <div>
              <i className="bi bi-calendar3 text-body-tertiary pe-1" />
              <span className="text-body-secondary fs-9 gap 2">
                {formatDate(meeting?.date)}
              </span>
            </div>
          </>
        ) : (
          <div className="d-flex align-items-center gap-2 w-100">
            <input
              type="text"
              className="form-control form-control-sm flex-grow-1"
              value={editedName}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleSave();
                }
                if (e.key === "Escape") {
                  setEditedName(meeting?.title || "");
                  setIsEditing(false);
                }
              }}
              onChange={(e) => setEditedName(e.target.value)}
              autoFocus
            />

            <button className="btn btn-sm btn-success" onClick={handleSave}>
              <i className={`wb ${Icons("correct")}`} />
            </button>

            <button
              className="btn btn-sm btn-danger"
              onClick={() => {
                setEditedName(meeting?.title || "");
                setIsEditing(false);
              }}
            >
              <i className={`wb ${Icons("cancel")}`} />
            </button>
          </div>
        )}
      </div>
      <div className="d-flex align-items-center gap-2">
        {displayTimezone && (
          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            data-bs-toggle="modal"
            data-bs-target="#meetingTimezoneModal"
          >
            <i className={`wb ${Icons("view")}`} />
            Timezone: {displayTimezone}
          </button>
        )}
        {Array.isArray(meeting?.participants) && (
          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={onShowParticipants}
          >
            <i className={`wb ${Icons("view")}`} />
            Participants ({meeting.participants.length})
          </button>
        )}
        {meeting?.summary && meeting.summary.trim() !== "" && (
          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={onShowSummary}
          >
            <i className={`wb ${Icons("view")}`} />
            Full Summary
          </button>
        )}
        {meeting?.transcript &&
          typeof meeting.transcript === "string" &&
          meeting.transcript.trim() !== "" &&
          meeting.transcript.trim() !== "[]" && (
            <button
              className="btn btn-primary btn-sm d-flex align-items-center gap-2"
              onClick={onShowTranscript}
            >
              <i className={`wb ${Icons("view")}`} />
              Full Transcript
            </button>
          )}
        <button
          className="btn btn-sm btn-danger d-flex align-items-center gap-2"
          onClick={() => onDelete(meeting.uuid)}
        >
          <i className={`wb ${Icons("remove")}`} />
          Delete
        </button>
      </div>
    </div>
  );
};

export default MeetingHeader;
